import React, { useState } from 'react';
import { Button, Result, Spin, Tag, Typography, message } from 'antd';
import { LoadingOutlined, SettingOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import AgentConfigWizard from './components/AgentConfigWizard';
import {
  fetchAgentConfiguration,
  selectAgentConfigLoading,
  selectAgentConfiguration,
  selectIsChatbotConfigured,
  selectShouldShowConfigSteps,
  setShouldShowConfigSteps,
  updateAgentConfiguration,
} from '../../reduxToolkit/corpusSlice';

import Corpus from '../corpus/pages/Index';

const Agent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentBrand } = useSelector((state) => state.app);
  const shouldShowConfigSteps = useSelector(selectShouldShowConfigSteps);
  const agentConfig = useSelector(selectAgentConfiguration);
  const isChatbotConfigured = useSelector(selectIsChatbotConfigured);
  const agentConfigLoading = useSelector(selectAgentConfigLoading);
  const [messageApi, contextHolder] = message.useMessage();
  const [showWizard, setShowWizard] = useState(shouldShowConfigSteps);

  React.useEffect(() => {
    setShowWizard(shouldShowConfigSteps);
  }, [shouldShowConfigSteps]);

  React.useEffect(() => {
    if (currentBrand?.brand_id) {
      dispatch(fetchAgentConfiguration({ brandId: currentBrand.brand_id }));
    }
  }, [currentBrand?.brand_id, dispatch]);

  React.useEffect(() => {
    if (agentConfig?.configuration || agentConfig?.configurations) {
      dispatch(setShouldShowConfigSteps(false));
    }
  }, [agentConfig, dispatch]);

  const handleComplete = async (config) => {
    if (!currentBrand?.brand_id) return;
    try {
      const resp = await dispatch(
        updateAgentConfiguration({
          brandId: currentBrand.brand_id,
          configuration: config,
        }),
      ).unwrap();

      console.log({ resp });

      if (resp) {
        dispatch(setShouldShowConfigSteps(false));
        setShowWizard(false);
        messageApi.success(
          'Agent configuration saved. You can upload RAG files next.',
        );
      } else {
        messageApi.error(
          resp?.message || 'Failed to save configuration. Please try again.',
        );
      }
    } catch (err) {
      messageApi.error(
        err?.message || 'Failed to save configuration. Please try again.',
      );
    }
  };

  return (
    <div className="h-screen bg-gray-100 flex flex-col overflow-hidden">
      <div className="flex-1 overflow-auto px-4 py-8">
        <div className="mx-auto w-full max-w-6xl flex-1 flex flex-col gap-6">
          {contextHolder}
          <div className="mx-auto w-full max-w-6xl flex flex-col gap-6">
            {(showWizard || shouldShowConfigSteps) && (
              <div className="flex flex-wrap items-start justify-between gap-4">
                <div>
                  <Typography.Title level={3} className="!mb-1 text-gray-900">
                    WhatsApp AI
                  </Typography.Title>
                  <Typography.Text type="secondary">
                    Lock your business profile, tone, and knowledge base before
                    going live.
                  </Typography.Text>
                </div>
                <div className="flex items-center gap-3">
                  <Tag
                    color={shouldShowConfigSteps ? 'orange' : 'green'}
                    className="rounded-full px-3 py-1 text-sm"
                  >
                    {shouldShowConfigSteps
                      ? 'Configuration pending'
                      : 'Configuration Competed'}
                  </Tag>
                  {/* <Button
                    icon={<SettingOutlined />}
                    onClick={() => setShowWizard(true)}
                  >
                    Edit settings
                  </Button> */}
                </div>
              </div>
            )}

            {agentConfigLoading && !agentConfig ? (
              <div className="flex items-center justify-center h-[60vh]">
                <Spin indicator={<LoadingOutlined spin />} size="large" />
              </div>
            ) : showWizard || shouldShowConfigSteps ? (
              <AgentConfigWizard
                onComplete={handleComplete}
                showUploadCta
                onGoToUploads={() => navigate('/user/data-sources')}
                onClose={() => setShowWizard(false)}
                showHeading={false}
                isFirstSetup={!isChatbotConfigured}
                initialConfig={
                  agentConfig?.configuration ||
                  agentConfig?.configurations ||
                  {}
                }
              />
            ) : (
              <div className="w-full">
                <Corpus classNames="" />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Agent;
